import { Route, Routes, Navigate } from "react-router-dom";
import HomePage from "../pages/HomePage";

// New KODE IA pages
import WalletsPage from "../pages/WalletsPage";
import AiDataPage from "../pages/AiDataPage";
import CaseStudiesPage from "../pages/CaseStudiesPage";
import CompanyPage from "../pages/CompanyPage";
import ContactPage from "../pages/ContactPage";

// Wallet product pages
import BogowiProductPage from "../pages/BogowiProductPage";
import BWeb3Page from "../pages/BWeb3Page";
import EasyChainPage from "../pages/EasyChainPage";
import BDidPage from "../pages/BDidPage";

// AI & Data product pages
import IslasVivasPage from "../pages/IslasVivasPage";
import ProductivityPage from "../pages/ProductivityPage";
import DocumentsPage from "../pages/DocumentsPage";

// Legacy pages — kept reachable for old inbound links / active campaigns,
// but no longer surfaced in the main nav.
import AboutUsPage from "../pages/OurFootPrintPage";
import TeamPage from "../pages/TeamPage";
import ServicesPage from "../pages/ServicesPage";
import KitDigitalPage from "../pages/KitDigitalPage";
import InnovationPage from "../pages/InnovationPage";
import AIAgentsPage from "../pages/AIAgentsPage";
import MVPBuildPage from "../pages/MVPBuildPage";
import MVPBuilderProgramPage from "../pages/MVPBuilderProgramPage";
import GrantApplicationPage from "../pages/GrantApplicationPage";
import SovnPage from "../pages/SovnPage";

const RoutesContainer = () => {
  return (
    <Routes>
      {/* Home */}
      <Route path="/" element={<HomePage />} />

      {/* Wallets block */}
      <Route path="/wallets" element={<WalletsPage />} />
      <Route path="/wallets/bogowi"    element={<BogowiProductPage />} />
      <Route path="/wallets/b-web3"    element={<BWeb3Page />} />
      <Route path="/wallets/easychain" element={<EasyChainPage />} />
      <Route path="/wallets/b-did"     element={<BDidPage />} />

      {/* AI & Data block */}
      <Route path="/ai-data" element={<AiDataPage />} />
      <Route path="/ai-data/islas-vivas"  element={<IslasVivasPage />} />
      <Route path="/ai-data/productivity" element={<ProductivityPage />} />
      <Route path="/ai-data/documents"    element={<DocumentsPage />} />

      {/* Case studies, Company, Contact */}
      <Route path="/case-studies" element={<CaseStudiesPage />} />
      <Route path="/company"      element={<CompanyPage />} />
      <Route path="/contact"      element={<ContactPage />} />

      {/* Legacy redirects from old URLs to their new homes */}
      <Route path="/bogowi"        element={<Navigate to="/wallets/bogowi" replace />} />
      <Route path="/get-in-touch"  element={<Navigate to="/contact" replace />} />

      {/* Legacy pages still reachable by direct URL only */}
      <Route path="/our-footprint"        element={<AboutUsPage />} />
      <Route path="/team"                 element={<TeamPage />} />
      <Route path="/services"             element={<ServicesPage />} />
      <Route path="/innovation"           element={<InnovationPage />} />
      <Route path="/kit-digital"          element={<KitDigitalPage />} />
      <Route path="/ai-agents"            element={<AIAgentsPage />} />
      <Route path="/mvp-build"            element={<MVPBuildPage />} />
      <Route path="/mvp-builder-program"  element={<MVPBuilderProgramPage />} />
      <Route path="/grant-application"    element={<GrantApplicationPage />} />
      <Route path="/sovn"                 element={<SovnPage />} />
    </Routes>
  );
};

export default RoutesContainer;
